import { defineComponent, ref } from 'vue';
import ProvinceTableComponent from '@/components/provinceTable/ProvinceTable.vue';
import ProvinceFormComponent from '@/components/provinceTable/provinceForm/ProvinceForm.vue';

export default defineComponent({
  name: 'ProvincePage',
  components: {
    ProvinceTableComponent,
    ProvinceFormComponent
  },
  setup: () => {
    const provinceId = ref<number | null>(null);
    const provinceForm = ref<InstanceType<typeof ProvinceFormComponent>>();

    const createClick = () => {
      Promise.resolve(provinceId.value = null)
        .then(() => provinceForm.value?.show());
    };

    const editClick = (id: number) => {
      Promise.resolve(provinceId.value = id)
        .then(() => provinceForm.value?.show());
    };

    return {
      provinceForm,
      provinceId,
      createClick,
      editClick
    };
  },
});
